class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);


function applyDiscountCode() {
  // const sections = ['cart-drawer', 'cart-icon-bubble'];
   const sections = ['cart-drawer', 'main-cart-items', 'cart-icon-bubble'];

  // 1. Handle each .discount-component separately
  document.querySelectorAll('.discount-component').forEach(discountComponent => {
    const input = discountComponent.querySelector('.cart-discount__input');
    const applyBtn = discountComponent.querySelector('.applyDiscount');
    const errorEl = discountComponent.querySelector('.coupen-error');
    const appliedCoupon = discountComponent.querySelector('.applied-coupon-wrapper');
    // console.log("applies coupen",appliedCoupon);
    const removeBtn = discountComponent.querySelector('.remove-btn');

    //on load and on change fetch
    fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      // console.log("Cart",cart);
      const appliedDiscount = (cart.discount_codes?.[0]?.applicable)? cart.discount_codes[0].code: null;
      const errorEl = discountComponent.querySelector(".coupen-error");
      if(appliedDiscount){
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.add("hidden");
        }
        if(appliedDiscount){
          const appliedCoupon = discountComponent.querySelector(".applied-coupon-wrapper");
          appliedCoupon.classList.remove('hidden');
          appliedCoupon.querySelector(".cart-coupon").textContent = appliedDiscount;
        }
      }
    });
    //on load and on change fetch

    if (applyBtn) {
      applyBtn.addEventListener('click', () => {
        const discountCode = input.value.trim();

        if (!discountCode) {
          if (errorEl) {
            errorEl.classList.remove('hidden');
            errorEl.textContent = 'Coupon does not exist!';
          }
          return;
        }

        // Hide previous error
        if (errorEl) {
          errorEl.classList.add('hidden');
          errorEl.textContent = '';
        }
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            discount: discountCode,
            sections: sections
          })
        })
        .then(res => res.json())
        .then(response => {
          console.log("Response",response);
          // // ✅ Only update custom-cart-items and other known sections
          // if (response.sections) {
          //   for (const [sectionId, html] of Object.entries(response.sections)) {
          //     const container = document.getElementById(sectionId);
          //     if (container) {
          //       container.innerHTML = html;
          //     }
          //   }
          // }
    
          // ✅ Trigger cart drawer open if present
          const cartDrawer = document.querySelector('cart-drawer');
          const cartBtn = document.querySelector('#cart-icon-bubble');
    
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(response);
          }

          // Open via method, not a synthetic click on the cart <a href="/cart"> (iOS WebKit navigates).
          cartDrawer?.open(cartBtn);
    
          // ✅ Dispatch custom refresh event
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: response
          }));
    
          // ✅ Handle coupon result display
          const matchedCoupon = response.discount_codes?.find(codeObj =>
            codeObj.code.toUpperCase() === discountCode.toUpperCase()
          );
    
          setTimeout(() => {
            if (matchedCoupon && matchedCoupon.applicable === false) {
              if (errorEl) {
                errorEl.textContent = `Coupon "${matchedCoupon.code}" does not exist!`;
                errorEl.classList.remove("hidden");
              }
            } else {
              if (appliedCoupon) {
                appliedCoupon.classList.remove("hidden");
                appliedCoupon.querySelector(".cart-coupon").textContent =
                  matchedCoupon?.code || discountCode;
              }
            }
          }, 200);
        })
        .catch(err => {
          console.error("Discount apply error:", err);
        });
      });
    }

    // Remove discount
    if (removeBtn) {
      removeBtn.addEventListener('click', () => {
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            discount: '',
            sections: sections
          })
        })
        .then(res => res.json())
        .then(response => {
          if (appliedCoupon) {
            appliedCoupon.classList.add('hidden');
          }

          const cartDrawer = document.querySelector('cart-drawer');
          const cartbtn = document.querySelector('#cart-icon-bubble');
          cartDrawer?.classList.remove('is-empty');
          cartDrawer?.renderContents(response);
          // Open via method, not a synthetic click on the cart <a href="/cart"> (iOS WebKit navigates).
          cartDrawer?.open(cartbtn);
        });
      });
    }
  });

  // 2. Handle popup logic (shared global popup)
  const popup = document.querySelector('.offercode-popup');
  const overlay = document.querySelector('.offercode-overlay');
  const closeIcon = document.querySelector('.popup-close-icon');

  // Attach event to all "View Discount" buttons
  document.querySelectorAll('.view-discount-offer-button').forEach(offerButton => {
    offerButton.addEventListener('click', () => {
      popup?.classList.add('active');
      overlay?.classList.add('active');
    });
  });

  const closePopup = () => {
    popup?.classList.remove('active');
    overlay?.classList.remove('active');
  };

  closeIcon?.addEventListener('click', closePopup);
  overlay?.addEventListener('click', closePopup);

  // 3. Handle coupon buttons inside popup
  if (popup) {
    popup.querySelectorAll(".apply-button").forEach(couponBtn => {
      couponBtn.addEventListener('click', () => {
        const discountCode = couponBtn.closest(".coupon-row")?.getAttribute("data-couponcode");
        if (!discountCode) return;

        // Apply using first component (or you can enhance this to apply to all)
        const discountComponent = document.querySelector('.discount-component');
        if (discountComponent) {
          const input = discountComponent.querySelector('.cart-discount__input');
          if (input) input.value = discountCode;
          const applyBtn = discountComponent.querySelector('.applyDiscount');
          applyBtn?.click(); // trigger existing apply
        }

        closePopup();
      });
    });
  }
}

// function applyDiscountCode(){
  
//   // show discount codes Popup
//     const offerButton = document.querySelector('.view-discount-offer-button');
//     const popup = document.querySelector('.offercode-popup');
//     const overlay = document.querySelector('.offercode-overlay');
//     const closeIcon = document.querySelector('.popup-close-icon');
    
//     if (offerButton && popup && overlay) {
//       offerButton.addEventListener('click', function () {
//         popup.classList.add('active');
//         overlay.classList.add('active');
//       });
//     }
    
//     function closePopup() {
//       popup?.classList.remove('active');
//       overlay?.classList.remove('active');
//     }
    
//     closeIcon?.addEventListener('click', closePopup);
//     overlay?.addEventListener('click', closePopup);
//  // show discount codes Popup
  
//   function discountInCart(discountCode){
//     let sections = ['cart-drawer', 'cart-icon-bubble'];
//      fetch("/cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "Accept": "application/json"
//       },
//       body: JSON.stringify({
//       "discount":discountCode,
//         sections: sections
//       })
//     })
//     .then(res => res.json())
//     .then((response) => {
     
//       const cartbtn = document.querySelector('#cart-icon-bubble');
//       const cartDrawer = document.querySelector('cart-drawer');
      
//       cartDrawer.classList.remove('is-empty');          
//       cartDrawer.renderContents(response);
//       cartbtn.dispatchEvent(new Event("click", { bubbles: true }));
  
//       const matchedCoupon = response.discount_codes.find(codeObj => codeObj.code.toUpperCase() === discountCode.toUpperCase());
//       const errorEl = document.querySelector(".discount-component .coupen-error");
//       if (matchedCoupon && matchedCoupon.applicable === false) {
//         console.log("response.discount_codes.applicable", matchedCoupon.applicable);
    
//         if (errorEl) {
//           errorEl.textContent = `Coupon ${matchedCoupon.code} does not exist!`;
//           errorEl.classList.remove("hidden");
//         }
//       }else{
//         if (errorEl) {
//           errorEl.textContent = '';
//           errorEl.classList.add("hidden");
//         }
//         const appliedCoupon = document.querySelector(".applied-coupon-wrapper");
//         appliedCoupon.classList.remove('hidden');
//         appliedCoupon.querySelector(".cart-coupon").textContent = matchedCoupon.code;
//       }
//     })
//     .catch(error => {
//       console.error("Error updating cart:", error);
//     });
//   }
  
//   const applyDiscountBtn = document.querySelector(".applyDiscount");
//   console.log("applyDiscountBtn",applyDiscountBtn);
//   if(applyDiscountBtn){
//     applyDiscountBtn.addEventListener('click',function(){
//       const discountWrapper = this.closest(".discount-component");
//       const discountCode = discountWrapper.querySelector("input").value;
//       if(discountCode){
//         document.querySelector(".discount-component .coupen-error").classList.add("hidden");
//         document.querySelector(".discount-component .coupen-error").textContent = '';
//         console.log("discountCode",discountCode);
//         discountInCart(discountCode);
//       }else{
//         document.querySelector(".discount-component .coupen-error").classList.remove("hidden");
//         document.querySelector(".discount-component .coupen-error").textContent = 'Coupon does not exist!';
//       }
      
//     });
//   }

//   const coupenButtons = popup.querySelectorAll(".apply-button");
//   if(coupenButtons.length){
//     coupenButtons.forEach((couponBtn)=>{
//       couponBtn.addEventListener('click',function(){
//         const discountCode = couponBtn.closest(".coupon-row").getAttribute("data-couponcode");
//         discountInCart(discountCode);
//         popup.classList.remove('active');
//         overlay.classList.remove('active');
//       })
//     })
//   }
//   const removeBtn = document.querySelector('.applied-coupon-wrapper .remove-btn');
//   if (removeBtn) {
//     let sections = ['cart-drawer', 'cart-icon-bubble'];
//     removeBtn.addEventListener('click', function () {
//       fetch("/cart/update.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Accept": "application/json"
//         },
//         body: JSON.stringify({
//             "discount":'',
//               sections: sections
//         })
//       })
//       .then(res => res.json())
//       .then((response) => {
//         console.log("response",response);
//          const appliedCoupon = document.querySelector(".applied-coupon-wrapper");
//         appliedCoupon.classList.add('hidden');
  
//         const cartbtn = document.querySelector('#cart-icon-bubble');
//         const cartDrawer = document.querySelector('cart-drawer');
        
//         cartDrawer.classList.remove('is-empty');          
//         cartDrawer.renderContents(response);
//         cartbtn.dispatchEvent(new Event("click", { bubbles: true }));
//       });
//     });
//   }
// }


// ============================================================
// CART UPSELL - ROOT FIX WITH EVENT DELEGATION
// Event listeners are attached ONCE to document and persist
// across DOM updates. Only state initialization needs to re-run.
// ============================================================

// Helper function to handle option selection for a wrapper
function handleCartUpsellOptionSelection(optionElement, wrapper) {
  const variantList = wrapper.querySelector(".variant_list");
  if (!variantList) return;

  const variants = JSON.parse(variantList.dataset.variants || "[]");
  const priceWrapper = wrapper.querySelector(".price_wrapper");

  // Build selectedOptions from current DOM state
  const selectedOptions = {};
  wrapper.querySelectorAll(".option_group").forEach(group => {
    const selectedOpt = group.querySelector(".option_value.selected");
    if (selectedOpt) {
      selectedOptions[group.dataset.optionIndex] = selectedOpt.dataset.value;
    }
  });

  const index = optionElement.dataset.optionIndex;
  const value = optionElement.dataset.value;
  optionElement.closest(".option_group")?.setAttribute("data-selectedVal", value);

  if (index === "1") {
    const selectedOption1 = value;

    const matchedVariants = variants.filter(v => v.option1 === selectedOption1);
    const validOption2Values = [...new Set(matchedVariants.map(v => v.option2))];
    const validOption3Values = [...new Set(matchedVariants.map(v => v.option3))];

    const option2Group = wrapper.querySelector('[data-option-index="2"]');
    if (option2Group) {
      option2Group.querySelectorAll('.option_value').forEach(opt => {
        const val = opt.dataset.value;
        if (validOption2Values.includes(val)) {
          opt.classList.remove('hidden');
        } else {
          opt.classList.add('hidden');
          opt.classList.remove('selected');
        }
      });
    }

    const option3Group = wrapper.querySelector('[data-option-index="3"]');
    if (option3Group) {
      option3Group.querySelectorAll('.option_value').forEach(opt => {
        const val = opt.dataset.value;
        if (validOption3Values.includes(val)) {
          opt.classList.remove('hidden');
        } else {
          opt.classList.add('hidden');
          opt.classList.remove('selected');
        }
      });
    }

    ["2", "3"].forEach(optIndex => {
      const group = wrapper.querySelector(`[data-option-index="${optIndex}"]`);
      if (group) {
        const optionValues = Array.from(group.querySelectorAll(".option_value"));
        const visibleOptions = optionValues.filter(el => !el.classList.contains("hidden"));

        group.setAttribute("data-options_count", visibleOptions.length);

        const selectedVal = visibleOptions[0]?.dataset.value;
        if (selectedVal) {
          optionValues.forEach(el => el.classList.remove("selected"));
          visibleOptions[0].classList.add("selected");
          group.setAttribute("data-selectedval", selectedVal);
          selectedOptions[optIndex] = selectedVal;
        }
      }
    });
  }

  const siblings = optionElement.closest(".option_values").querySelectorAll(".option_value");
  siblings.forEach(el => el.classList.remove("selected"));
  optionElement.classList.add("selected");

  optionElement.closest(".option_values").classList.remove('active');
  selectedOptions[index] = value;

  const matchedVariant = variants.find(v => {
    return Object.keys(selectedOptions).every(i => v["option" + i] === selectedOptions[i]);
  });

  if (matchedVariant) {
    wrapper.querySelector("[crossell-addon-id]")?.setAttribute("crossell-addon-id", matchedVariant.id);
    wrapper.querySelector(".add-to-cart")?.setAttribute("data-crossellid", matchedVariant.id);
    wrapper.querySelector(".add-to-cart")?.setAttribute("data-crossell", matchedVariant);
    if (matchedVariant.featured_image?.src) {
      wrapper.querySelector("img").src = matchedVariant.featured_image.src;
    }

    const compareAt = matchedVariant.compare_at_price;
    const price = matchedVariant.price;
    const formattedComateAt = Shopify.formatMoney(compareAt, Shopify.money_format).replace(/\.00$/, "");
    const formattedPrice = Shopify.formatMoney(price, Shopify.money_format).replace(/\.00$/, "");
    let html = '';

    if (compareAt && compareAt > price) {
      const discount = compareAt - price;
      // Floor to match Liquid's integer division used everywhere else in the cart.
      const percentage = Math.floor((discount * 100) / compareAt);
      html += `<span class="sale_price">${formattedPrice}</span>`;
      html += `<span class="comapre_price">${formattedComateAt}</span>`;
      html += `<span class="discount_percentage">${percentage}% OFF</span>`;
    } else {
      html += `<span class="sale_price">${formattedPrice}</span>`;
      if (compareAt) {
        html += `<span class="comapre_price">${formattedComateAt}</span>`;
      }
    }

    if (priceWrapper) {
      priceWrapper.innerHTML = html;
    }
  }
}

// Helper function to handle add-to-cart click
function handleCartUpsellAddToCart(button) {
  const variantId = button.getAttribute("data-crossellid");
  if (!variantId) {
    console.warn("No variant selected to add to cart.");
    return Promise.resolve({ ok: false });
  }

  // Get the full variant object with pre-calculated properties
  const wrapper = button.closest(".crossell-item-wrapper");
  const variantListEl = wrapper.querySelector(".variant_list");
  const allVariants = variantListEl ? JSON.parse(variantListEl.dataset.variants || "[]") : [];
  const fullVariant = allVariants.find(v => v.id == variantId);

  let sections = ['cart-drawer', 'cart-icon-bubble'];
  console.log("variant-id", variantId);
  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: fullVariant?._properties || {},
      sections: sections
    })
  })
  .then((res) => res.json())
  .then((response) => {
    window.Shopify?.publish?.("cartUpdate", { source: "upsell" });
    const cartpage = document.body.classList.contains("template-cart");
    if(!cartpage){
      const cartbtn = document.querySelector('.header-cart-icon');
      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(response);
        // Open via the drawer's method, not a synthetic click on the <a href="/cart">
        // cart icon: new Event("click") is non-cancelable, so preventDefault() is a no-op
        // and iOS WebKit follows the href (pushes the user to /cart). open() avoids the anchor.
        cartDrawer.open(cartbtn);
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
    }else{
      window.location.href ='/cart';
    }

    dataLayer.push({
      'event': "add_to_cart_atCart_crossSell",
      'ecommerce': {
        'currency': "INR",
        'value': parseFloat(response.final_price.toFixed(2)),
        'items': [
          {
            'item_id': response.sku,
            'item_name': response.product_title,
            'discount': response.original_price - response.discounted_price,
            'index': 0,
            'item_brand': "SleepyCat",
            'item_category': response.product_type,
            'price': parseFloat(response.original_price.toFixed(2)),
            'product-variationId': response.variant_id,
            'variant': response.variant_title,
            'quantity': response.quantity,
            'deal-price': parseFloat(response.discounted_price.toFixed(2)),
            'product-category': response.product_type,
            'product-size': response.options_with_values.find(item => item.name === "DIMENSION")?.value,
            'product-color':  response.options_with_values.find(item => item.name === 'COLOR')?.value,
            'page-path': response.url
          }
        ]
      }
    });

    return { ok: true };
  })
  .catch(error => {
    console.error("Error adding to cart:", error);
    return { ok: false };
  });
}

// Setup delegated event listeners ONCE - these persist across DOM updates
// Uses single consolidated listener for performance (not 3 separate listeners)
const CartUpsellDelegation = (function() {
  let initialized = false;

  function handleClick(event) {
    // Check selectors in order of specificity (most specific first)

    // 1. Add-to-cart button (highest priority)
    const addToCartBtn = event.target.closest('.cart-upsell-wrapper .crossell-item-wrapper .add-to-cart');
    if (addToCartBtn) {
      event.preventDefault();
      if (addToCartBtn.classList.contains('add-to-cart--multi') && window.CartVariantSheet) {
        window.CartVariantSheet.open(addToCartBtn);
      } else {
        // Single-option card: add directly and show the same loader on the card.
        if (addToCartBtn.dataset.adding === '1') return; // guard double-clicks / dup adds
        addToCartBtn.dataset.adding = '1';
        const card = addToCartBtn.closest('.crossell-item-wrapper');
        const spinner = card && card.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        const result = handleCartUpsellAddToCart(addToCartBtn);
        if (result && typeof result.then === 'function') {
          result.then(function (r) {
            // On success the drawer re-renders (card removed) — only revert on failure.
            if (r && r.ok === false) {
              if (spinner) spinner.classList.add('hidden');
              addToCartBtn.dataset.adding = '0';
            }
          });
        }
      }
      return; // Stop processing - action handled
    }

    // 2. Option value selection
    const optionValue = event.target.closest('.cart-upsell-wrapper .option_value');
    if (optionValue) {
      const wrapper = optionValue.closest('.crossell-item-wrapper');
      if (wrapper) {
        handleCartUpsellOptionSelection(optionValue, wrapper);
      }
      return; // Stop processing - action handled
    }

    // 3. Option group click (to open dropdown) - only if NOT clicking on option_value
    const optionGroup = event.target.closest('.cart-upsell-wrapper .option_group');
    if (optionGroup) {
      // Double-check we're not inside an option_value (defensive)
      if (!event.target.closest('.option_value')) {
        const optionValues = optionGroup.querySelector(".option_values");
        if (optionValues) {
          optionValues.classList.add('active');
        }
      }
      return;
    }

    // 4. Click outside - close any open dropdowns
    const clickedInsideUpsell = event.target.closest('.cart-upsell-wrapper');
    if (!clickedInsideUpsell) {
      document.querySelectorAll('.cart-upsell-wrapper .option_values.active').forEach(el => {
        el.classList.remove('active');
      });
    }
  }

  return {
    init: function() {
      if (initialized) return;
      initialized = true;
      document.addEventListener('click', handleClick);
    }
  };
})();

// Initialize state for cross-sell items (select defaults, etc.)
// This is the only part that needs to run after DOM updates
function initCartUpsellState() {
  document.querySelectorAll(".cart-upsell-wrapper .crossell-item-wrapper").forEach(wrapper => {
    // Skip if already initialized
    if (wrapper.dataset.upsellInitialized === 'true') return;
    wrapper.dataset.upsellInitialized = 'true';

    const variantList = wrapper.querySelector(".variant_list");
    if (!variantList) return;

    const optionGroups = wrapper.querySelectorAll(".option_group");

    // Auto-select first available option per group
    optionGroups.forEach(group => {
      const optionIndex = group.dataset.optionIndex;
      const firstOption = group.querySelector(".option_value");
      if (firstOption && !group.querySelector(".option_value.selected")) {
        firstOption.classList.add("selected");
        group.setAttribute("data-selectedVal", firstOption.dataset.value);
      }
    });

    // Trigger initial option selection to set up variant
    const initiallySelectedOption = wrapper.querySelector('.option_value.selected');
    if (initiallySelectedOption) {
      handleCartUpsellOptionSelection(initiallySelectedOption, wrapper);
    }
  });
}

// Main function - maintains backward compatibility
function cartUpsell() {
  // Setup delegation once (idempotent) - uses optimized single listener
  CartUpsellDelegation.init();
  // Initialize state for any new elements
  initCartUpsellState();
}

// ── Variant selection bottom sheet (opened by the multi-option cross-sell Add) ──
window.CartVariantSheet = (function () {
  let state = null;

  const DIM_RE = /\d+(\.\d+)?\s*[x×]\s*\d+/i; // dimension value: "78 x 36" / "24 x 16 x 4"

  function sheetEl() { return document.getElementById('CartVariantSheet'); }

  function parseVariants(card) {
    const el = card.closest('.crossell-item-wrapper')?.querySelector('.variant_list');
    try { return el ? JSON.parse(el.dataset.variants || '[]') : []; }
    catch (e) { return []; }
  }

  // Build option metadata generically from the card's (hidden) option groups + the variant data.
  function buildOptions(card, variants) {
    const wrapper = card.closest('.crossell-item-wrapper');
    const meta = {};
    wrapper.querySelectorAll('.option_group').forEach(g => {
      const idx = parseInt(g.getAttribute('data-option-index'));
      if (!idx) return;
      const swatches = {};
      g.querySelectorAll('.option_value').forEach(v => { swatches[v.dataset.value] = v.getAttribute('style') || ''; });
      meta[idx] = { name: g.getAttribute('option_name') || ('Option ' + idx), isColor: g.classList.contains('color'), swatches: swatches };
    });
    const options = [];
    [1, 2, 3].forEach(idx => {
      const key = 'option' + idx;
      const values = [];
      variants.forEach(v => { const val = v[key]; if (val && values.indexOf(val) === -1) values.push(val); });
      if (values.length <= 1) return; // single/empty option needs no section
      const m = meta[idx] || { name: 'Option ' + idx, isColor: false, swatches: {} };
      const isDim = values.some(val => DIM_RE.test(val));
      options.push({ index: idx, name: m.name, isColor: m.isColor, isDim: isDim, swatches: m.swatches, values: values, hidden: false });
    });
    // When a dimension option exists, the categorical size (e.g. "Category": Single/Queen) is redundant —
    // the dimension already encodes it (LxB / LxBxH). Keep it for variant-matching but don't render it.
    if (options.some(o => o.isDim)) {
      options.forEach(o => {
        const nm = (o.name || '').toLowerCase();
        if (!o.isDim && !o.isColor && (nm === 'category' || nm === 'size')) o.hidden = true;
      });
    }
    return options;
  }

  // Classify every option index so the summary can always show dimension + pack size, even when
  // they're a single fixed value with no selectable section.
  function buildRoles(card, variants) {
    const wrapper = card.closest('.crossell-item-wrapper');
    const names = {};
    const colorFlag = {};
    if (wrapper) {
      wrapper.querySelectorAll('.option_group').forEach(g => {
        const idx = parseInt(g.getAttribute('data-option-index'));
        if (!idx) return;
        names[idx] = (g.getAttribute('option_name') || '').toLowerCase();
        colorFlag[idx] = g.classList.contains('color');
      });
    }
    const roles = [];
    [1, 2, 3].forEach(idx => {
      const key = 'option' + idx;
      if (!variants.some(v => v[key])) return; // index not used by this product
      const nm = names[idx] || '';
      roles.push({
        index: idx,
        isColor: colorFlag[idx] || false,
        isDim: variants.some(v => v[key] && DIM_RE.test(v[key])),
        isPack: nm.indexOf('pack') !== -1,
        isCategory: nm === 'category' || nm === 'size'
      });
    });
    return roles;
  }

  function capitalize(s) { return s ? s.replace(/-/g, ' ').replace(/(^|\s)\w/g, c => c.toUpperCase()) : s; }

  function convertDim(value, unit) {
    const parts = value.split(/\s*[x×]\s*/i).map(p => parseFloat(p)).filter(n => !isNaN(n));
    if (!parts.length) return value;
    let conv, suffix;
    if (unit === 'cm') { conv = parts.map(v => (v * 2.54).toFixed(1)); suffix = ' cm'; }
    else if (unit === 'feet') { conv = parts.map(v => (v / 12).toFixed(2).replace(/\.0+$/, '').replace(/(\.\d)0+$/, '$1')); suffix = ' feet'; }
    else { conv = parts.map(v => String(v)); suffix = ' Inch'; }
    return conv.join(' x ') + suffix;
  }

  function getMatched() {
    if (!state) return null;
    return state.variants.find(v => state.options.every(o => String(v['option' + o.index]) === String(state.selected[o.index])));
  }

  // Global availability: selectable if ANY available variant carries the value. Drives only the
  // greyed `is-unavailable` styling. Must be global because selection is snap-to-variant — a value
  // reachable via another combination has to stay clickable, not blocked by pointer-events:none.
  function isValueAvailable(option, value) {
    return state.variants.some(v => v.available && String(v['option' + option.index]) === String(value));
  }

  function money(cents) {
    try { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents, Shopify.money_format).replace(/\.00$/, '') : '₹' + Math.round(cents / 100); }
    catch (e) { return '₹' + Math.round(cents / 100); }
  }

  function render() {
    const sheet = sheetEl();
    const body = sheet.querySelector('[data-vs-options]');
    body.innerHTML = '';
    state.options.forEach(option => {
      if (option.hidden) return; // redundant categorical size (covered by the dimension)
      const section = document.createElement('div');
      section.className = 'vs-section';

      const head = document.createElement('div');
      head.className = 'vs-section__head';
      const label = document.createElement('span');
      label.className = 'vs-section__label';
      label.textContent = (option.isColor ? 'Choose ' : 'Select ') + capitalize(option.name) + ':';
      head.appendChild(label);
      if (option.isDim) {
        const units = document.createElement('div');
        units.className = 'vs-units';
        ['inches', 'cm', 'feet'].forEach(u => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'vs-unit' + (state.unit === u ? ' is-active' : '');
          b.textContent = u === 'inches' ? 'inch' : u;
          b.addEventListener('click', () => { state.unit = u; render(); });
          units.appendChild(b);
        });
        head.appendChild(units);
      }
      section.appendChild(head);

      if (option.isColor) {
        const wrap = document.createElement('div');
        wrap.className = 'vs-swatches';
        option.values.forEach(val => {
          const sw = document.createElement('div');
          sw.className = 'vs-swatch' + (state.selected[option.index] === val ? ' is-selected' : '') + (isValueAvailable(option, val) ? '' : ' is-unavailable');
          const dot = document.createElement('div');
          dot.className = 'vs-swatch__dot';
          if (option.swatches[val]) dot.setAttribute('style', option.swatches[val]);
          const nm = document.createElement('div');
          nm.className = 'vs-swatch__name';
          nm.textContent = val;
          sw.appendChild(dot); sw.appendChild(nm);
          sw.addEventListener('click', () => select(option.index, val));
          wrap.appendChild(sw);
        });
        section.appendChild(wrap);
      } else {
        const grid = document.createElement('div');
        grid.className = 'vs-grid';
        option.values.forEach(val => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'vs-option-btn' + (state.selected[option.index] === val ? ' is-selected' : '') + (isValueAvailable(option, val) ? '' : ' is-unavailable');
          b.textContent = option.isDim ? convertDim(val, state.unit) : val;
          b.addEventListener('click', () => select(option.index, val));
          grid.appendChild(b);
        });
        section.appendChild(grid);
      }
      body.appendChild(section);
    });
    renderSummary();
  }

  function renderSummary() {
    const sheet = sheetEl();
    // Two summary slots exist (top for desktop, footer for mobile); only one is visible
    // per breakpoint, but we populate both so either can render without a resize handler.
    const sums = sheet.querySelectorAll('[data-vs-summary]');
    const confirmBtn = sheet.querySelector('[data-vs-confirm]');
    const v = getMatched();
    if (!v) { sums.forEach(function (s) { s.innerHTML = ''; }); confirmBtn.disabled = true; return; }
    confirmBtn.disabled = false;
    // Meta from the matched variant via roles, so dimension + pack size always show. Category is
    // suppressed when a dimension exists (the dimension already encodes the size).
    const roles = state.roles || [];
    const hasDim = roles.some(r => r.isDim);
    const meta = roles.map(function (r) {
      const val = v['option' + r.index];
      if (!val) return null;
      if (r.isCategory && hasDim) return null; // redundant with the dimension
      return r.isDim ? convertDim(val, state.unit) : val;
    }).filter(Boolean).join(' | ');
    const hasCompare = v.compare_at_price && v.compare_at_price > v.price;
    // Floor to match Liquid's integer division (times:100 | divided_by) used for the
    // cart-item badge, cross-sell cards, and bill summary — keeps the discount % consistent
    // across every cart surface and never overstates the saving.
    const off = hasCompare ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
    const img = (v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
    const html =
      (img ? '<div class="vs-summary__img-box"><img class="vs-summary__img" src="' + img + '" alt=""></div>' : '') +
      '<div class="vs-summary__info">' +
        '<div class="vs-summary__head">' +
          '<div class="vs-summary__title">' + state.title + '</div>' +
          (meta ? '<div class="vs-summary__meta">' + meta + '</div>' : '') +
        '</div>' +
        '<div class="vs-summary__price-row">' +
          '<div class="vs-summary__prices">' +
            '<span class="vs-summary__sale">' + money(v.price) + '</span>' +
            (hasCompare ? '<span class="vs-summary__mrp">' + money(v.compare_at_price) + '</span>' : '') +
          '</div>' +
          (hasCompare ? '<span class="vs-summary__off">' + off + '% OFF</span>' : '') +
        '</div>' +
      '</div>';
    sums.forEach(function (s) { s.innerHTML = html; });
  }

  // Snap-to-variant: adopt the available variant that carries the clicked value and best preserves
  // the user's other visible choices, copying ALL its option values. Keeps the selection equal to a
  // real variant (getMatched never null), so every offered variant stays reachable on any pool.
  function select(index, value) {
    if (!state) return;
    const candidates = state.variants.filter(function (v) {
      return v.available && String(v['option' + index]) === String(value);
    });
    if (!candidates.length) return;
    let best = candidates[0];
    let bestScore = -1;
    candidates.forEach(function (v) {
      let score = 0;
      state.options.forEach(function (o) {
        if (o.index === index || o.hidden) return; // score visible selections only
        if (String(v['option' + o.index]) === String(state.selected[o.index])) score++;
      });
      if (score > bestScore) { bestScore = score; best = v; }
    });
    state.options.forEach(function (o) { state.selected[o.index] = best['option' + o.index]; });
    render();
  }

  function open(button) {
    const sheet = sheetEl();
    if (!sheet) return;
    const variants = parseVariants(button);
    if (variants.length < 2) { handleCartUpsellAddToCart(button); return; }
    const options = buildOptions(button, variants);
    if (!options.length) { handleCartUpsellAddToCart(button); return; }
    const card = button.closest('.crossell-item-wrapper');
    const title = card.querySelector('.item_title') ? card.querySelector('.item_title').textContent.trim() : '';
    // Seed from a real available variant — independent per-option defaults can form an impossible combo.
    const defaultVariant = variants.find(v => v.available) || variants[0];
    const selected = {};
    options.forEach(o => { selected[o.index] = defaultVariant['option' + o.index]; });
    const roles = buildRoles(card, variants);
    state = { button: button, variants: variants, options: options, selected: selected, unit: 'inches', title: title, roles: roles };
    render();
    setLoading(false);
    sheet.hidden = false;
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    document.addEventListener('keyup', onKey);
  }

  // Toggle the cart-item-style loader inside the sheet + lock the Confirm button.
  function setLoading(on) {
    const sheet = sheetEl();
    if (!sheet) return;
    const spinner = sheet.querySelector('.loading__spinner');
    const confirmBtn = sheet.querySelector('[data-vs-confirm]');
    if (spinner) spinner.classList.toggle('hidden', !on);
    if (confirmBtn) confirmBtn.disabled = on;
  }

  function close() {
    const sheet = sheetEl();
    if (!sheet) return;
    setLoading(false);
    sheet.classList.remove('is-open');
    document.removeEventListener('keyup', onKey);
    setTimeout(() => { sheet.hidden = true; }, 280);
    state = null;
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  function confirm() {
    if (!state) return;
    const v = getMatched();
    if (!v) return;
    state.button.setAttribute('data-crossellid', v.id);
    // Show the same loader as cart items while the add is in flight; keep the sheet
    // open until the item is actually added, then close it. (On success the drawer
    // re-render also replaces the sheet, so close() is a no-op safety net.)
    setLoading(true);
    const result = handleCartUpsellAddToCart(state.button);
    if (result && typeof result.then === 'function') {
      result.then(function (r) {
        if (r && r.ok === false) {
          setLoading(false); // failed — keep sheet open so the user can retry
        } else {
          close();
        }
      });
    } else {
      close();
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#CartVariantSheet [data-vs-close], #CartVariantSheet .cart-variant-sheet__overlay')) { close(); return; }
    if (e.target.closest('#CartVariantSheet [data-vs-confirm]')) { confirm(); return; }
  });

  return { open: open, close: close };
})();
// function cartUpsell() {
//   document.querySelectorAll("cart-drawer-items .crossell-item-wrapper").forEach(wrapper => {
//     const variantList = wrapper.querySelector(".variant_list");
//     if (!variantList) return;

//     const variants = JSON.parse(variantList.dataset.variants || "[]");
//     const priceWrapper = wrapper.querySelector(".price_wrapper");
//     const optionGroups = wrapper.querySelectorAll(".option_group");
//     const selectedOptions = {};

//     // Auto-select first available option per group
//     optionGroups.forEach(group => {
//       const optionIndex = group.dataset.optionIndex;
//       const firstOption = group.querySelector(".option_value");
//       if (firstOption) {
//         selectedOptions[optionIndex] = firstOption.dataset.value;
//         firstOption.classList.add("selected");
//         group.setAttribute("data-selectedVal", firstOption.dataset.value);
//       }
//     });

//     // Open options dropdown on group click (if not clicking on option)
//     optionGroups.forEach(group => {
//       group.addEventListener('click', function (event) {
//         if (!event.target.classList.contains('option_value')) {
//           this.querySelector(".option_values").classList.add('active');
//         }
//       });
//     });

//     // Handle option selection
//     wrapper.querySelectorAll(".option_value").forEach(option => {
//       option.addEventListener("click", function () {
//         const index = this.dataset.optionIndex;
//         const value = this.dataset.value;

//         // Set selected value
//         const optionGroup = this.closest(".option_group");
//         optionGroup?.setAttribute("data-selectedVal", value);

//         // Deselect siblings and select this one
//         const siblings = this.closest(".option_values").querySelectorAll(".option_value");
//         siblings.forEach(el => el.classList.remove("selected"));
//         this.classList.add("selected");

//         // Hide dropdown
//         this.closest(".option_values").classList.remove('active');
//         selectedOptions[index] = value;

//         // Find matching variant
//         const matchedVariant = variants.find(v => {
//           return Object.keys(selectedOptions).every(i => {
//             return v["option" + i] === selectedOptions[i];
//           });
//         });

//         if (matchedVariant) {
//           // Update variant ID
//           wrapper.querySelector("[crossell-addon-id]")?.setAttribute("crossell-addon-id", matchedVariant.id);
//           wrapper.querySelector(".add-to-cart")?.setAttribute("data-crossellid", matchedVariant.id);

//           // Update image
//           if (matchedVariant.featured_image?.src) {
//             wrapper.querySelector("img").src = matchedVariant.featured_image.src;
//           }

//           // Format price
//           const compareAt = matchedVariant.compare_at_price;
//           const price = matchedVariant.price;
//           const formattedCompareAt = Shopify.formatMoney(compareAt, Shopify.money_format).replace(/\.00$/, "");
//           const formattedPrice = Shopify.formatMoney(price, Shopify.money_format).replace(/\.00$/, "");

//           let html = '';

//           if (compareAt && compareAt > price) {
//             const discount = compareAt - price;
//             const percentage = Math.round((discount * 100) / compareAt);
//             html += `<span class="compare_price">+ ${formattedCompareAt}</span>`;
//             html += `<span class="sale_price">+ ${formattedPrice}</span>`;
//             html += `<span class="discount_percentage">(${percentage}% OFF)</span>`;
//           } else {
//             if (compareAt) {
//               html += `<span class="compare_price">+ ${formattedCompareAt}</span>`;
//             }
//             html += `<span class="sale_price">+ ${formattedPrice}</span>`;
//           }

//           if (priceWrapper) {
//             priceWrapper.innerHTML = html;
//           }
//         }
//       });
//     });
//   });

//   // Add to cart handler
//    document.querySelectorAll("cart-drawer-items .crossell-item-wrapper .add-to-cart").forEach(button => {
//     button.addEventListener("click", function () {
//       const variantId = this.getAttribute("data-crossellid");
  
//       if (!variantId) {
//         console.warn("No variant selected to add to cart.");
//         return;
//       }
//      let sections = ['cart-drawer', 'cart-icon-bubble'];
//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Accept": "application/json"
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: 1,
//           sections: sections
//         })
//       })
//       .then((res) => res.json())
//       .then((response) => { 
//             const cartbtn = document.querySelector('#cart-icon-bubble');
//             const cartDrawer = document.querySelector('cart-drawer');
            
//             cartDrawer.classList.remove('is-empty');          
//             cartDrawer.renderContents(response);
//             cartbtn.dispatchEvent(new Event("click", { bubbles: true }));
//         })
//       .catch(error => {
//         console.error("Error adding to cart:", error);
//       });
//     });
//   });
// }


class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
    cartUpsell();
    applyDiscountCode();
    // CUSTOM CODE
      var cart_count = document.querySelector("cart-drawer-items").getAttribute("data-item-count");
      var stickybarCount = document.querySelector(".sticky-bar-wrap .cart_item_count");
      if(stickybarCount) stickybarCount.innerHTML = cart_count;

    // CUSTOM CODE
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          // .drawer__heading-count (the "(N Items)" text) lives outside <cart-drawer-items>
          // in the markup, so it was never covered by this refresh even when this method
          // did run — added here alongside the two selectors that already were.
          const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.drawer__heading-count'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.main-cart-contents',
      },
      // {
      //   id: 'cart-icon-bubble',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section',
      // },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          // getSectionsToRender() above only ever covered the /cart PAGE's own
          // sections (main-cart-items, main-cart-footer) — never the drawer's own
          // item list or heading count. Those normally get refreshed by
          // onCartUpdate() reacting to the cartUpdate event this same action
          // publishes below, but connectedCallback()'s subscriber explicitly skips
          // that for source: 'cart-items' (this class's own publishes) to avoid a
          // redundant second fetch on the /cart page, where getSectionsToRender()
          // already has it covered. That guard has no such redundancy for the
          // drawer instance though — nothing else was refreshing it, which is why
          // the drawer's item count/list went stale and any stale/duplicate DOM
          // there never got a chance to self-correct. Calling it directly (not
          // through the filtered event) fixes that without touching the /cart
          // page's behavior at all.
          if (this.tagName === 'CART-DRAWER-ITEMS') {
            this.onCartUpdate();
          }
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
      cartUpsell();
      applyDiscountCode();
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Cart-offer coupon copy-to-clipboard. Lives here (cart.js is a persistent <script src> loaded once
// per page) rather than inline in the drawer markup: the drawer re-renders via innerHTML, and inline
// scripts injected that way never execute — so an inline handler silently fails to attach after an
// add-to-cart re-render (notably when the cart started empty on load). Delegated on document, so it
// works no matter when the offer cards enter the DOM.
(function () {
  if (window._cartOfferCopyInit) return;
  window._cartOfferCopyInit = true;

  function showCopied(btn) {
    btn.classList.add('is-copied');
    // Reset any in-flight hide timer so rapid re-clicks extend the toast instead of one stale
    // timer clearing it early.
    clearTimeout(btn._copiedTimer);
    btn._copiedTimer = setTimeout(function () { btn.classList.remove('is-copied'); }, 1400);
  }

  // Synchronous fallback for when the async Clipboard API is unavailable or rejects.
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:-9999px;';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  // One delegated listener for the whole page (never re-bound on cart re-renders). The two cheap
  // guards below short-circuit the vast majority of clicks before the closest() tree-walk.
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-offer-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-code');
    if (!code) return;
    // Prefer the async Clipboard API; fall back to execCommand if it's missing OR rejects (no
    // permission / not focused). Toast only flips on an actual successful copy.
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code)
        .then(function () { showCopied(btn); })
        .catch(function () { if (legacyCopy(code)) showCopied(btn); });
    } else if (legacyCopy(code)) {
      showCopied(btn);
    }
  });
})();
